import React, { useEffect } from "react";
import { DetailDrawer } from "./DetailDrawer";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { useUserModel } from "../userModel";
import { TransferOrgDrawer } from "./TransferOrgDrawer";
import { PwdDrawer } from "./PasswordDrawer";

export function User() {
    const {
        loadData,
        resetState,
        loadDs,
    } = useUserModel()
    useEffect(() => {
        loadDs()
        loadData({ pageNum: 1 }, {}).then()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetState])
    return (
        <>
            <PageHeader />
            <DataBox />
            <DetailDrawer />
            <PwdDrawer />
            <TransferOrgDrawer />
        </>
    );
}

